import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { ReportService } from '../../../services/report/report.service';
import { ClientSettingsService } from '../../../services/client-settings/client-settings.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnDestroy {

  open = false;
  reportCategories;
  variantsFeatureEnabled = false;

  reportsLoaded: Subscription;
  clientSettingsLoaded: Subscription;

  constructor(
    private reportService: ReportService,
    private clientSettingsService: ClientSettingsService,
  ) { }

  ngOnInit() {
    this.reportCategories = this.reportService.getReportCategories();
    this.variantsFeatureEnabled = this.clientSettingsService.isReportVariantsEnabled();

    this.reportsLoaded = this.reportService.reportsLoadedObservable().subscribe(reportsData => {
      this.reportCategories = reportsData.reportCategories;
    });

    this.clientSettingsLoaded = this.clientSettingsService.clientSettingsLoadedObservable().subscribe(() => {
      this.variantsFeatureEnabled = this.clientSettingsService.isReportVariantsEnabled();
    });
  }

  ngOnDestroy() {
    this.reportsLoaded.unsubscribe();
    if (this.clientSettingsLoaded) this.clientSettingsLoaded.unsubscribe();
  }

  toggleMenu() {
    this.open = !this.open;
  }

  toggleCategory(category) {
    category.active = !category.active;
  }

  setActiveReport(report) {
    console.log('setActiveReport', report);
    event.stopPropagation();
    this.open = false;

    // this.reportService.setActiveReport(report);
    
    /*
    this.reportService.loadReportWithContext({
      key: report.key,
      reportId: report._id
    });
    */
  }

}
